import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";

import { LoaderService} from '../services/loader.service';

@Injectable({
    providedIn: 'root'
  })

  export class LoaderInterceptor implements HttpInterceptor{
      constructor(public loaderService : LoaderService){
      }
      intercept(req:HttpRequest<any>, next:HttpHandler): Observable<HttpEvent<any>>{
          
          var requestUrl = req.url,
          substring = "getrequestors"

          if(requestUrl.includes(substring))
          {           
            return next.handle(req).pipe(
                finalize(() => this.loaderService.hide())
            );
          }
          else
          {
            this.loaderService.show();
            return next.handle(req).pipe(
                finalize(() => this.loaderService.hide())
            );
          }

      }
  }
